module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Umbrella-3725b8e80225b77f756890efe0d34e24.svg";